var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 10.875H22.5C22.0641 10.875 21.6675 11.1267 21.4819 11.5214L19.8047 15.0858L16.0884 0.840937C15.9595 0.345 15.5114 0 15 0C14.9911 0 14.9808 0 14.9709 0.0009375C14.4497 0.0140625 14.0044 0.385312 13.8984 0.897187L10.3434 18.0778L8.58422 11.7014C8.44969 11.2134 8.00531 10.8755 7.49906 10.8755H0.75C0.335625 10.8755 0 11.2111 0 11.6255V12.3755C0 12.7898 0.335625 13.1255 0.75 13.1255H6.64313L9.41625 23.1745C9.48158 23.4118 9.623 23.6211 9.81878 23.7702C10.0146 23.9193 10.2539 24.0001 10.5 24C10.5117 24 10.5248 24 10.5366 23.9991C11.0564 23.9822 11.4961 23.6114 11.6016 23.1028L15.1261 6.06656L18.4116 18.6591C18.5302 19.117 18.9244 19.4517 19.3959 19.4948C19.8881 19.5483 20.3156 19.2825 20.5181 18.8541L23.2134 13.125H29.25C29.6644 13.125 30 12.7894 30 12.375V11.625C30 11.2106 29.6644 10.875 29.25 10.875Z",
    fill: "#8497B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardGrey);
export default __webpack_public_path__ + "static/media/dashboard_grey.2818f0887434d63d7da91aaf22d7147d.svg";
export { ForwardRef as ReactComponent };